import { MenuIcon, UserCircle2Icon } from "lucide-react";
import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/app/hooks";
import { toggleSidebar } from "../../redux/features/modalSlice";
import { fetchAdminProfileAsync } from "../../redux/features/adminSlice";
import { useNavigate } from "react-router-dom";

const Header = () => {
  // Example count for notifications
  // const notificationCount = 5;
  const dispatch = useAppDispatch();
  const { adminProfile } = useAppSelector((state) => state.admin);
  const { user }: any = useAppSelector((state) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchAdminProfileAsync());
  }, [dispatch]);

  return (
    <header className="flex items-center justify-between bg-white shadow p-4">
      <div className="text-gray-700 text-lg font-semibold">Dashboard</div>
      <div className="flex items-center space-x-4">
        <div className="relative">
          {/* <button className="text-gray-700 hover:text-gray-900 focus:outline-none">
            <Bell />
          </button> */}
          {/* {notificationCount > 0 && (
            <span className="absolute -top-1 -right-1 bg-primary text-white text-xs font-bold rounded-full w-4 h-4 flex items-center justify-center">
              {notificationCount}
            </span>
          )} */}
        </div>
        <button
          className="flex items-center space-x-2"
          onClick={() => navigate("/settings")}
        >
          <span className="text-gray-700">
            Hi,{" "}
            {user?.user?.roles === "INVESTOR"
              ? "User"
              : adminProfile?.firstName}
          </span>
          <UserCircle2Icon className="text-primary" />
        </button>
        <MenuIcon
          className="lg:hidden"
          onClick={() => dispatch(toggleSidebar())}
        />
      </div>
    </header>
  );
};

export default Header;
